import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { theme } = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const getButtonStyles = () => {
    if (theme === 'modern') {
      return 'fixed bottom-8 right-8 modern-button-primary p-4 rounded-xl shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 z-50 backdrop-blur-sm border border-white/20';
    }
    return 'fixed bottom-8 right-8 bg-yellow-400 border-4 border-black rounded-lg p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-2 hover:-translate-x-2 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:rotate-3 transition-all duration-300 z-50 transform-gpu';
  };

  const getIconStyles = () => {
    if (theme === 'modern') {
      return 'text-xl text-white';
    }
    return 'text-xl text-black';
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={getButtonStyles()}
          aria-label={t('scrollTop.ariaLabel')}
        >
          <FaArrowUp className={getIconStyles()} />
        </button>
      )}
    </>
  );
};

export default ScrollToTop; 